import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import Loader from "../../../Components/MainLayout/Loader";
import Header from "../../../Components/MainLayout/Header";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class New extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Complaint: [],
      formData: {
        school: "",
        name: "",
        phone_no: "",
        complain: "",
      },
      loading: false,
      alertMessage: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Complaint";
  }

  handleClick = () => {
    this.setState({ loading: true });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.state.loading) return;

    this.setState({ loading: true });

    const { formData } = this.state;
    if (!formData.complain || !formData.complain.trim()) {
      this.setState({ loading: false, alertMessage: true });
      return;
    }

    try {
      const fd = new FormData();
      fd.append("user", this.props.user.user.id);
      fd.append("school", this.props.user.user.school.id);
      fd.append("name", this.props.user.user.first_name);
      fd.append("phone_no", this.props.user.user.sms_number);
      fd.append("complain", formData.complain);
      fd.append("status", "true");
      fd.append("session", this.props.user.session.id);

      await axios.post(`/api/complaint`, fd);
      this.props.history.push({ pathname: "/prevComplaint" });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { formData, loading } = this.state;
    const canSubmit = !!(formData.complain && formData.complain.trim());
    return (
      <div>
        <Header to="/home" title="Complaints" />

        <div className="d-flex flex-row th-no-scroll pt-2">
          <Link style={{ textDecoration: "none" }} to="/prevComplaint">
            <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
              <div className="th-black">Previous</div>
            </div>
          </Link>

          <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
            <div className="th-primary">Register New</div>
            <hr
              className="w-100 my-1 th-border"
              style={{ borderWidth: 5, borderRadius: 5 }}
            />
          </div>
        </div>

        <div className="container">
          <div className="rounded">
            <form onSubmit={this.handleSubmit} autoComplete="off">
              <div className="input-group input-group shadow-sm">
                <textarea
                  className="form-control th-input-primary"
                  placeholder="Complaint"
                  style={{ minHeight: 200 }}
                  name="complain"
                  value={formData.complain}
                  onChange={this.handleChange}
                />
              </div>
              <div className="d-flex justify-content-end py-3">
                {loading ? (
                  <div className="my-1 pr-2">
                    <Loader />
                  </div>
                ) : null}
                <button
                  type="submit"
                  className="th-btn-primary px-4 py-2"
                  disabled={loading || !canSubmit}
                >
                  {loading ? "Submitting..." : "SUBMIT"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(New));
